export const hasSpecialCharError = { hasSpecialChar: true };

export function hasSpecialCharacter(str: string) {
  return /[^a-zA-Z0-9]/.test(str);
}
